export default "__VITE_ASSET__hSf73NoV__"